<template>
	<div class="pt-2">
    <ExpansionExclusiveArea v-if="$route.params.id == 'expansion'"/>
    <LiningExclusiveArea v-if="$route.params.id == 'lining'"/>
	</div>
</template>

<script>

export default {
	components: {
		ExpansionExclusiveArea: () => import("./customer_orders/ExpansionExclusiveArea.vue"),
		LiningExclusiveArea: () => import("./customer_orders/LiningExclusiveArea.vue"),
	},

}
</script>